import { render, staticRenderFns } from "./PolandStats.vue?vue&type=template&id=cafb35ec&scoped=true&"
import script from "./PolandStats.vue?vue&type=script&lang=js&"
export * from "./PolandStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb35ec",
  null
  
)

export default component.exports